// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './card.scss';

/**
 * Card Component
 *
 * @param {String} customClass - Custom wrapper class
 * @param {Node} children - React Node
 */

const Card = ({ customClass, children }) => (
    <div className={`card-wrapper ${customClass}`}>{children}</div>
);

Card.propTypes = {
    children: PropTypes.node.isRequired,
    customClass: PropTypes.string,
};

export default Card;
